module.exports = __webpack_public_path__ + "img/117.765e689b.jpg";